import {
  useEffect,
  useState
} from 'react'

import {
  Button,
  Spin,
  Typography
} from 'antd'
import { SEARCH } from 'configs/path'
import { useAppSelector } from 'hooks'
import { useMagazine } from 'hooks/useMagazine'
import { IBook } from 'models/book'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'
import { bindParams } from 'utilities/helpers'
import BookCard from 'web/BookCard/BookCard'

const HomePC = () => {
  const { magazinesPuchase, hasMore, loadMore, loading, search_header, magazineDigital, decodeURIComponentSafely } = useMagazine()
  const location = useLocation()
  const app = useAppSelector((s) => s.app.app_id)
  const { t } = useTranslation()
  const [listMagazine, setListMagazine] = useState<IBook[]>([])

  useEffect(() => {
    const safeMagazineDigital = magazineDigital || []
    const safeMagazinesPurchase = magazinesPuchase || []

    const combinedMagazines = [
      ...safeMagazineDigital,
      ...safeMagazinesPurchase.filter((magazine) => magazine && magazine.isDisplay)
    ]

    // Remove duplicates by ID (only if magazine and magazine.id exist)
    const uniqueMagazines = combinedMagazines.reduce((acc, magazine) => {
      if (magazine && magazine.id != null && !acc.has(magazine.id)) {
        acc.set(magazine.id, magazine)
      }
      return acc
    }, new Map<number, IBook>())

    const magazinesWithoutDuplicates = Array.from(uniqueMagazines.values())

    // Sort magazine
    const sortedMagazines = magazinesWithoutDuplicates.sort((a, b) => {
      const now = new Date().getTime()
      const getSortDate = (magazine: IBook) => {
        const publishAt = magazine.publish_at ? new Date(magazine.publish_at).getTime() : null
        const distributionStartAt = magazine.distribution_start_at ? new Date(magazine.distribution_start_at).getTime() : null

        // Helper function to round down to minute (remove seconds and milliseconds)
        const roundToMinute = (timestamp: number) => {
          const date = new Date(timestamp)
          date.setSeconds(0, 0)
          return date.getTime()
        }

        // publish_at null -> return distributionStartAt
        if (publishAt === null) {
          return distributionStartAt ? roundToMinute(distributionStartAt) : null
        }

        // publish_at future date -> return distributionStartAt
        if (publishAt > now) {
          return distributionStartAt ? roundToMinute(distributionStartAt) : roundToMinute(publishAt)
        }

        // publish_at not future date -> return publishAt
        return roundToMinute(publishAt)
      }

      const sortDateA = getSortDate(a)
      const sortDateB = getSortDate(b)

      if (sortDateA === null && sortDateB === null) {
        return 0
      }

      if (sortDateA === null) {
        return -1
      }
      if (sortDateB === null) {
        return 1
      }

      if (sortDateA !== sortDateB) {
        return sortDateB! - sortDateA!
      }

      return b.id - a.id
    })
    setListMagazine(sortedMagazines)
  }, [magazinesPuchase, magazineDigital])

  return (
    <div className="home-page-pc-container">
      <Typography className="text-all">
        {decodeURIComponentSafely(location.pathname) === bindParams(SEARCH, { app: app})
          ? `${t('search_result')} : ${search_header}`
          : t('all')}
      </Typography>

      <div className="home-page-pc-content">
        {listMagazine.length > 0 &&
          listMagazine.map((pdf: IBook, index) => {
            return <BookCard pdf={pdf} id={pdf.id} key={index} />
          })}
      </div>

      {listMagazine.length === 0 && !loading && (
        <Typography style={{ marginLeft: '1rem' }}>
          {decodeURIComponentSafely(location.pathname) === bindParams(SEARCH, { app: app})
            ? t('no_data_list_magazine')
            : t('no_data')}
        </Typography>
      )}
      {loading && (
        <div className="loading-container">
          <Spin />
        </div>
      )}
      {hasMore && !loading && (
        <div style={{ width: '100%', display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
          <Button onClick={loadMore} type="primary">
            {t('next_page', { page: 20 })}
          </Button>
        </div>
      )}
    </div>
  )
}

export default HomePC
